(function () {
    'use strict';

    angular
        .module('app')
        .controller('GroupEditController', GroupEditController);

    GroupEditController.$inject = ['debug', '$stateParams', 'API', 'helpers', 'alert', 'i18n', '$state',];

    function GroupEditController(debug, $stateParams, API, helpers, alert, i18n, $state) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.group = {};
        vm.groupTypes = [];
        vm.groupTeachers = [];
        vm.loadingState = {
            'groupIsLoading': false,
            'groupUsageIsLoading': false,
        };

        vm.parents = [];
        vm.teachers = [];
        vm.children = [];
        vm.students = [];

        vm.groupUsage = {
            labels: [],
            data: [],
        };

        vm.notEditable = false;
        vm.resourceExpand = 'users,school,contracts';

        vm.openMoveGroupModal = openMoveGroupModal;
        vm.openDisconnectUserModal = openDisconnectUserModal;
        vm.openDisconnectContractModal = openDisconnectContractModal;
        vm.openConnectExistingTeacherModal = openConnectExistingTeacherModal;
        vm.openRemoveModal = openRemoveModal;
        vm.addParent = addParent;
        vm.addTeacher = addTeacher;
        vm.addChild = addChild;
        vm.addStudent = addStudent;

        vm.now = helpers.getDatabaseDatetime();

        activate();

        function activate() {
            loadGroup();
            loadGroupUsage();
        }

        function addParent() {
            $state.go('users.add', {
                groupId: vm.id,
                schoolId: vm.group.school ? vm.group.school.id : null,
                userType: 'parent'
            });
        }
        function addTeacher() {
            $state.go('users.add', {
                groupId: vm.id,
                schoolId: vm.group.school ? vm.group.school.id : null,
                userType: 'teacher'
            });
        }
        function addChild() {
            $state.go('users.add', {
                groupId: vm.id,
                schoolId: vm.group.school ? vm.group.school.id : null,
                userType: 'child'
            });
        }
        function addStudent() {
            $state.go('users.add', {
                groupId: vm.id,
                schoolId: vm.group.school ? vm.group.school.id : null,
                userType: 'student'
            });
        }

        function loadGroup() {
            vm.loadingState.groupIsLoading = true;
            API.Group.get({ id: vm.id, expand: vm.resourceExpand }).$promise.then(function (response) {
                vm.group = response;
                angular.forEach(response.users, function(user) {
                    switch (user.user_type) {
                        case 'parent':
                            vm.parents.push(user);
                            break;
                        case 'teacher':
                            vm.teachers.push(user);
                            break;
                        case 'student':
                            vm.students.push(user);
                            break;
                        case 'child':
                            vm.children.push(user);
                            break;
                        default:

                            break;
                    }
                });
                vm.notEditable = Boolean(vm.group.fk_third_party_entity_id);
                vm.loadingState.groupIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadGroupUsage() {
            vm.loadingState.groupUsageIsLoading = true;

            var promise = API.Group.usage({ id: vm.id }).$promise;
            promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.groupUsage.labels.push(day.date);
                    vm.groupUsage.data.push(day.count);
                });
                vm.loadingState.groupUsageIsLoading = false;
            }, function () {
                vm.loadingState.groupUsageIsLoading = false;
            });
        }

        function openConnectExistingTeacherModal() {
            var promise = alert.prompt('connect-existing-teacher-to-group', { group: vm.group });
            promise.then(function(response) {
                vm.group.users.push(response);
                vm.teachers.push(response);
            }, function(response) {
                debug.log(response);
            });
        }

        function openDisconnectContractModal(contractId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {
                var promise = API.Contract.disconnectGroup({
                    id: contractId,
                    groupId: vm.id
                }).$promise;

                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadGroup();
                }, function () {
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openDisconnectUserModal(userId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {
                var promise = API.User.removeFromGroup({
                    id: userId,
                    target: vm.id
                }).$promise;

                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    angular.forEach(['parents', 'teachers', 'students', 'children'], function(userType) {
                        angular.forEach(vm[userType], function(user, index) {
                            if (user.id === userId) {
                                vm[userType].splice(index, 1);
                            }
                        });
                    });
                }, function () {
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openMoveGroupModal() {
            var promise = alert.prompt('move-group', { group: vm.group, schoolId: vm.group.fk_school_id });
            promise.then(function() {
                loadGroup();
            }, function(response) {
                debug.log(response);
            });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.Group.recycle({ id: vm.id }).$promise;

                removePromise.then(function() {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('GROUP_RECYCLED') });
                    $state.go('groups.list');
                }, function() {});
            }, function() {});
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;
                var promise = vm.group.$save({ expand: vm.resourceExpand });
                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.now = helpers.getDatabaseDatetime();
                }, function (response) {
                    debug.error(response);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
            }
        }
    }
})();